// extracted by mini-css-extract-plugin
export default {"warper":"Boxes_warper__eFr6r","box":"Boxes_box__vIX3y"};